var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4589_249586)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4589_249586)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37262 14.9984L-17.8698 19.7169L-19.4448 18.4344L-16.7858 17.0184L-14.4277 11.1399L-17.8698 2.5651L1.37262 7.28366L1.37262 2.23682L13.9996 11.1399L1.37262 20.0452L1.37262 14.9984Z",
    fill: "#0C7497"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.202401 13.7162L-19.4448 18.4347L-16.0027 9.85989L-19.4448 1.28288L-0.2024 6.00144L-0.2024 0.954591L12.4246 9.85989L-0.202401 18.763L-0.202401 13.7162Z",
    fill: "#00C0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.37287 20.0445L-0.202149 18.762L12.4249 9.85889L13.9999 11.1392L1.37287 20.0445Z",
    fill: "#1497AD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4589_249586",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -20,
    y: 0,
    width: 33,
    height: 19
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.202889 13.7162L-19.4453 18.4347L-16.0032 9.85989L-19.4453 1.28288L-0.202889 6.00144L-0.202888 0.954591L12.4241 9.85989L-0.202889 18.763L-0.202889 13.7162Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4589_249586)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.201516 13.7162L-19.4439 18.4347L-16.0018 9.85989L-19.7271 1.15375L-0.201516 6.00144L-0.201516 0.954591L12.9953 9.21426L-0.201516 18.763L-0.201516 13.7162Z",
    stroke: "url(#paint0_linear_4589_249586)",
    strokeWidth: 0.636364,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M-23.7803 28.1508L-23.7803 9.80615L16.6989 9.80615L16.6989 28.1508L-23.7803 28.1508Z",
    fill: "url(#paint1_linear_4589_249586)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4589_249586",
    x1: -3.35692,
    y1: 0.775128,
    x2: -3.35692,
    y2: 18.9556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4589_249586",
    x1: -1.92178,
    y1: 18.8121,
    x2: -11.6273,
    y2: 19.4812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4589_249586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.0909,
    height: 14,
    fill: "white",
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 0 0.95459)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4589_249586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.0909,
    height: 14,
    fill: "white",
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 -0.000488281 0.95459)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowTask);
export default __webpack_public_path__ + "static/media/follow-task.c290a153e10f3970b4d36684b20aeb97.svg";
export { ForwardRef as ReactComponent };